module.exports = __webpack_public_path__ + "img/slowsick_banner.2cd20ab0.jpg";